//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ArticlePreviewCard',
  props: {
    article: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: 'column'
    },
    headingLines: {
      type: Number,
      default: 3
    },
    lines: {
      type: Number,
      default: 3
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showFullImage: {
      type: Boolean,
      default: false
    },
    noSpacer: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: ''
    },
    hasShadow: {
      type: Boolean,
      default: false
    },
    hasCardBorder: {
      type: Boolean,
      default: false
    },
    isLastChild: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    isLazyImg: {
      type: Boolean,
      default: true
    },
    isPartnerContent: {
      type: Boolean,
      default: false
    },
    hasTitleAtTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadedImg: false,
      brokenImg: false
    }
  },
  computed: {
    id() {
      return this.article.externalId
    },
    location() {
      const location = this.article.country != null ? this.article.country.name : this.article.region?.name
      return location?.toUpperCase()
    },
    cardClass() {
      const classes = [`is-flex-direction-${this.direction}`]

      if (this.showFullImage) classes.push('full-image-preview')
      if (this.noBorder) classes.push('no-border')
      if (!this.hasShadow) classes.push('is-shadowless')
      if (this.background) classes.push(this.background)

      return classes.join(' ')
    }
  },
  methods: {
    navigate() {
      if (this.article.redirectUrl) window.location.href = this.article.redirectUrl
      else {
        this.$router.push({
          path: `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${
            this.article.externalId
          }`
        })
      }
    }
  }
}
